// Third-party Library
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Avatar, Tag, Space, message, Steps } from "antd";
import { LeftOutlined } from "@ant-design/icons";

// Constants
import { ROUTES, COMMON_FEATURES, TEMPLATE } from "../../../../constants";

// Components
import { BulkFooter } from "./components/BulkFooter";
import { BulkDownload, BulkUpload, BulkReview } from "./components";
import { ButtonLink } from "../../../../components";

//handler
import { getAvatarColor, getTagColor } from "./handler";
import { filter } from "../../../../handlers";

// Action Library
import * as REDUX_ACTION from "../../../../services/redux/actions";

// Redux Actions
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Styles
import "./index.css";
import styles from "./index.module.css";
import classes from "../../../index.module.css";

const { equalHDLR } = filter
const { EMPLOYEE_INDEX } = TEMPLATE.EMPLOYEE

const { reduxStoreWrapper } = REDUX_UTIL;

const BulkEmployee = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();

  const [current, setCurrent] = useState(0);
  const [srcData, setSrcData] = useState([]);
  const [completedData, setCompletedData] = useState([]);

  useEffect(() => {
    const newCompletedData = equalHDLR.objectEqual2(srcData, EMPLOYEE_INDEX);
    setCompletedData(newCompletedData);
  }, [srcData]);

  const completedChecked = completedData.some(obj => Object.values(obj).includes(null));

  const nextPage = () => setCurrent(current + 1);

  const nextHDLR = () => {
        const newSrc = srcData.map((n) => {
          const coid = n?.coid.split("/")
          return {
            ...n,
            coid: coid[0],
            company_name: coid[1]
          }
        })

        messageApi.open({
          type: "loading",
          content: "Validating employees data...",
          duration: 0,
        });

        dispatch( 
          REDUX_ACTION.v1_employee.validate_bulk_upload_employee_request(
            { employees: newSrc },
            ({ status, msg, dataSuccess, dataFailed }) => {
              
              const mergedData = [...dataSuccess, ...dataFailed];

              if (status === 200) {
                messageApi.destroy();
                message.success(msg); 
                nextPage()
                setSrcData(mergedData)
              } else {
                messageApi.destroy();
                message.error(msg);
              }
            }
          )
        );
  };


  const steps = [
    {
      title: "Download Template",
      content: <BulkDownload />,
      number: 1,
      icon: <span></span>,
      footer: <BulkFooter next={nextPage} completed="true" />,
    },
    {
      title: "Upload Template",
      content: <BulkUpload setSrcData={setSrcData} />,
      number: 2,
      icon: <span></span>,
      footer: <BulkFooter next={nextHDLR} completed={srcData.length > 0} />,
    },
    {
      title: "View Summary",
      content: <BulkReview srcData={srcData} setSrcData={setSrcData} completed={!completedChecked} />,
      number: 3,
      icon: <span></span>,
    },
  ];

  const items = steps.map((item, index) => ({
    key: item.title,
    icon: item.icon,
    title: (
      <Tag color={getTagColor(current, index)} className={styles["step-title"]}>
        <Avatar
          size="small"
          style={{
            backgroundColor: getAvatarColor(current, index),
          }}
        >
          {item.number}
        </Avatar>
        <span style={{ marginLeft: 8 }}>{item.title}</span>
      </Tag>
    ),
  }));

  return (
    <>{contextHolder}
    <div className={classes.container}>
      <ButtonLink
        onClick={() =>
          navigate(ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EMPLOYEE])
        }
        style={{ margin: current === 2 ? "0 4em" : "initial" }}
      >
        <Space>
          <LeftOutlined />
          <h3 className={styles["nav-title"]}>Employee List</h3>
        </Space>
      </ButtonLink>

      <Steps className={styles["container-step"]} type="navigation" current={current} items={items} size="small" />
      <div className={current === 2 ? styles["container-form2"] : styles["container-form"]}>
        <div className={styles["step"]}> {steps[current].content}</div>
        <div className={styles["btn-next"]}>{steps[current].footer}</div>
      </div>
    </div>
    </>
  );
};

export default BulkEmployee;
